import { render } from "./RevenueCategories.vue?vue&type=template&id=04300b4b&scoped=true"
import script from "./RevenueCategories.vue?vue&type=script&lang=js"
export * from "./RevenueCategories.vue?vue&type=script&lang=js"

import "./RevenueCategories.vue?vue&type=style&index=0&id=04300b4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04300b4b"]])

export default __exports__